import { all, Effect } from "redux-saga/effects"
import { Injector } from "../di/Injector"
import { watchSendResultByEmail } from "./sagas/watchSendContactEmail"

export function* email(injector: Injector): Generator<Effect> {
  yield all([watchSendResultByEmail(injector)])
}
